import { isObject } from "lodash";

function calculaDigitoVerificadorOriginal(num) {
    var tag, i, a, b, c, d = 0, e, dv;
    if (!num) {
        return null;
    }
    tag = '00000000' + parseInt(num, 10);
    tag = tag.substring(tag.length - 8);
    for (i = 0; i < 8; i++) {
        a = tag[i] * (9 - i);
        b = a % 10;
        c = (a - b) / 10;
        d += b + c;
    }
    e = 100 - d;
    dv = e % 10;
    return dv;
};

/**
 * Para prefijos nuevos: 005 y 006
 * @param {*} num 
 */
function calculaDigitoVerificadorNuevo({ prefijo, numero }) {
    // TODO: pendiente
    return 0;
}

/**
 * Devuelve el dígito verificador o null si si el tag no es válido.
 * @param {Tag} or {number} tag 
 */
export function calculaDigitoVerificador(tag) {
    if (isObject(tag)) {
        if (tag.prefijo === 'IMDM' || tag.prefijo === 'CPFI') {
            return calculaDigitoVerificadorOriginal(tag.numero);
        } else {
            return calculaDigitoVerificadorNuevo(tag);
        }
    } else {
        return calculaDigitoVerificadorOriginal(tag);
    }
}

const re = /^(\s*[0-9]){8}-?\d\s*$/;

export function verificaTag(prefijo, numero) {
    let dv, tagNum;
    if (!numero) {
        return false;
    }
    if (!re.test(numero)) {
        return false;
    }
    tagNum = parseInt(numero, 10);
    if (prefijo === 'IMDM' || prefijo === 'CPFI') {
        dv = calculaDigitoVerificador(getNumber(numero));
    } else {
        // TODO: falta calcular dv para prefijos 005 y 006
        return false;
    }
    return dv === tagNum % 10 ? true : false;
};

/* Devuelve número sin dígito verificador */
export function getNumber(tagNum) {
    tagNum = parseInt(tagNum, 10);
    return Math.floor(tagNum / 10);
};